module.exports = __webpack_public_path__ + "img/art-work-icon11.f372e16b.png";